<template>
  <CSidebar 
    fixed light
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="../assets/logo-white.png" height="48">
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>

<style scoped>
/deep/.c-sidebar-brand,
/deep/.c-sidebar-minimizer
{
  background: #444444;
}
/deep/.c-sidebar-nav
{
  background: #5e5e5e !important;
}

/deep/a > img
{
  width: 80%;
  height: auto;
}
</style>
